import { Link } from "react-router-dom";
import { Twitter, Instagram, Facebook, Youtube } from "lucide-react";
import NotifyMeButton from "@/components/NotifyMeButton";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-titans-navy border-t border-[rgba(138,141,143,0.2)] mt-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <img
            src="/titan-standard-logo.webp"
            alt="The Titan Standard"
            className="h-24 w-auto object-contain"
          />
          <p className="mt-4 font-display uppercase tracking-wide text-lg text-white" data-testid="footer-slogan">
            Every Snap. Every Story.
          </p>
          <p className="mt-2 text-titans-silver max-w-sm font-body">
            The official voice of Two-Tone Blue Nation. Live scores, roster, sharp analysis, and the loudest fan takes — all in one place.
          </p>
          <div className="flex gap-3 mt-6">
            {[
              { Icon: Twitter, name: "twitter" },
              { Icon: Instagram, name: "instagram" },
              { Icon: Facebook, name: "facebook" },
              { Icon: Youtube, name: "youtube" },
            ].map(({ Icon, name }) => (
              <a
                key={name}
                href="#"
                data-testid={`footer-social-${name}`}
                className="border border-[rgba(138,141,143,0.3)] p-2.5 text-titans-silver hover:text-white hover:border-titans-red transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
          <div className="mt-6" data-testid="footer-notify">
            <NotifyMeButton variant="compact" />
          </div>
        </div>
        <div>
          <div className="font-cond uppercase tracking-[0.2em] text-xs text-titans-silver mb-4">Team</div>
          <ul className="space-y-2 font-body text-sm">
            <li><Link to="/schedule" className="hover:text-titans-blue">Schedule</Link></li>
            <li><Link to="/roster" className="hover:text-titans-blue">Roster</Link></li>
            <li><Link to="/stats" className="hover:text-titans-blue">Stats</Link></li>
            <li><Link to="/breaking-news" className="hover:text-titans-blue">Breaking News</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-cond uppercase tracking-[0.2em] text-xs text-titans-silver mb-4">Fans</div>
          <ul className="space-y-2 font-body text-sm">
            <li><Link to="/analysis" className="hover:text-titans-blue">Analysis</Link></li>
            <li><Link to="/offseason" className="hover:text-titans-blue">Offseason</Link></li>
            <li><Link to="/community?tab=polls" className="hover:text-titans-blue">Polls</Link></li>
            <li><Link to="/community" className="hover:text-titans-blue">Fan Zone</Link></li>
            <li><Link to="/roster?tab=cap" className="hover:text-titans-blue">Cap Central</Link></li>
            <li><Link to="/roster?tab=depth" className="hover:text-titans-blue">Depth Chart</Link></li>
            <li><Link to="/history" className="hover:text-titans-blue">Heritage</Link></li>
            <li><Link to="/about" className="hover:text-titans-blue">About</Link></li>
            <li><a href="#newsletter" className="hover:text-titans-blue">Newsletter</a></li>
            <li><Link to="/newsletter/archive" className="hover:text-titans-blue" data-testid="footer-link-newsletter-archive">Newsletter Archive</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[rgba(138,141,143,0.2)] py-5">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-cond uppercase tracking-wider text-titans-muted">
          <div>© {new Date().getFullYear()} The Titan Standard. All rights reserved. · <span className="normal-case text-titans-muted/80" data-testid="footer-data-source">Data: ESPN / NFL.com. Independent fan site — not affiliated with the NFL or Tennessee Titans.</span></div>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/about" className="hover:text-titans-blue" data-testid="footer-link-about">About</Link>
            <Link to="/editorial-standards" className="hover:text-titans-blue" data-testid="footer-link-editorial">Editorial Standards</Link>
            <Link to="/corrections" className="hover:text-titans-blue" data-testid="footer-link-corrections">Corrections</Link>
            <Link to="/ownership" className="hover:text-titans-blue" data-testid="footer-link-ownership">Ownership</Link>
            <Link to="/contact" className="hover:text-titans-blue" data-testid="footer-link-contact">Contact</Link>
            <Link to="/privacy" className="hover:text-titans-blue" data-testid="footer-link-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-titans-blue" data-testid="footer-link-terms">Terms</Link>
            <Link to="/cookies" className="hover:text-titans-blue" data-testid="footer-link-cookies">Cookies</Link>
            <Link
              to="/admin"
              data-testid="footer-owner-link"
              className="text-titans-muted hover:text-titans-blue transition-colors"
            >
              Owner
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
